<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> Add Dispatch Devices</span>
    </div>
  </div>

  @if (isUploadBoxVisible) {
    <div class="component-container">
      <div class="component-header">
        <h6 class="component-title">Upload Dispatch Device File</h6>
        <div class="component-actions">
          <button
            class="primary-button"
            (click)="downloadMyFile()"
            type="button"
          >
            Download Sample Template
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <form [formGroup]="addDispatchDeviceForm" novalidate>
          <div class="form-section">
            <!-- Dispatch File Upload -->
            <div class="form-group">
              <label for="file" class="form-label">Dispatch File Upload</label>
              <mat-form-field
                class="file-upload-container"
                appearance="outline"
              >
                <mat-label>Dispatch File Upload</mat-label>

                <!-- Display File Name or Placeholder -->
                <input
                  matInput
                  type="text"
                  id="file"
                  formControlName="file"
                  [value]="addDispatchDeviceForm.controls['file'].value"
                  readonly
                />

                <!-- Hidden File Input -->
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  aria-label="File"
                  class="d-none"
                  (change)="onFileChange($event)"
                  #fileInput
                />

                <!-- Custom Upload Button -->
                <button
                  mat-button
                  class="upload-btn"
                  (click)="fileInput.click()"
                  type="button"
                >
                  <mat-icon>attach_file</mat-icon>
                </button>

                <!-- Error Message -->
                @if (
                  addDispatchDeviceForm.controls['file'].touched &&
                  addDispatchDeviceForm.controls['file'].errors?.required
                ) {
                  <mat-error> This field is Mandatory. </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section -->
      <div class="component-footer">
        <div class="button-group">
          <button
            type="button"
            [disabled]="!fileName"
            class="edit-button"
            (click)="saveDeviceDetails()"
          >
            Upload <mat-icon class="btn-icon">edit</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
  @if (!isUploadBoxVisible) {
    @if (dispatchDuplicateDeviceList.length > 0) {
      <div class="component-container">
        <div class="component-header error-header">
          <h6 class="component-title">Duplicate Device List</h6>
          <div class="component-actions">
            <button
              type="button"
              class="primary-button"
              (click)="
                exportToExcelDuplicateDispatchedDeviceData(
                  dispatchDuplicateDeviceList
                )
              "
              [disabled]="dispatchDuplicateDeviceList.length === 0"
            >
              Export Duplicate Devices
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Device IMEI</th>
                <th>Device UIN</th>
                <th>Device ICCID</th>
                <th>Device Model Name</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              @for (
                item of dispatchDuplicateDeviceList
                  | paginate
                    : {
                        id: 'batchPaginateDispatchDuplicateDeviceList',
                        itemsPerPage: size3,
                        currentPage: currentPage3,
                        totalItems: dispatchDuplicateDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.IMEI }}</td>
                  <td>{{ item.UIN }}</td>
                  <td>{{ item.ICCID }}</td>
                  <td>{{ item['TCU Model Name'] }}</td>
                  <td>{{ item.validationErrors }}</td>
                </tr>
              }
            </tbody>
            @if (dispatchDuplicateDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                      tabindex="0"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (dispatchDuplicateDeviceList.length !== 0) {
            <app-common-component-pagination
              [totalItems]="dispatchDuplicateDeviceList.length"
              [pageSize]="size3"
              [currentPage]="currentPage3"
              (pageChange)="onPageChange3($event)"
              (sizeChange)="onSizeChange3($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }

    @if (dispatchInvalidDeviceList.length > 0) {
      <div class="component-container">
        <div class="component-header error-header">
          <h6 class="component-title">Invalid Device List</h6>
          <div class="component-actions">
            <button
              type="button"
              class="primary-button"
              (click)="
                exportToExcelInvalidDispatchedDeviceData(
                  dispatchInvalidDeviceList
                )
              "
              [disabled]="dispatchInvalidDeviceList.length === 0"
            >
              Export Invalid Devices
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Device IMEI</th>
                <th>Device UIN</th>
                <th>Device ICCID</th>
                <th>Device Model Name</th>
                <th>Remark</th>
              </tr>
            </thead>
            <tbody>
              @for (
                item of dispatchInvalidDeviceList
                  | paginate
                    : {
                        id: 'batchPaginateDispatchInvalidDeviceList',
                        itemsPerPage: size2,
                        currentPage: currentPage2,
                        totalItems: dispatchInvalidDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.IMEI }}</td>
                  <td>{{ item.UIN }}</td>
                  <td>{{ item.ICCID }}</td>
                  <td>{{ item['TCU Model Name'] }}</td>
                  <td>{{ item.validationErrors }}</td>
                </tr>
              }
            </tbody>
            @if (dispatchInvalidDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                      tabindex="0"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (dispatchInvalidDeviceList.length !== 0) {
            <app-common-component-pagination
              [totalItems]="dispatchInvalidDeviceList.length"
              [pageSize]="size2"
              [currentPage]="currentPage2"
              (pageChange)="onPageChange2($event)"
              (sizeChange)="onSizeChange2($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }

    @if (dispatchUploadedDeviceList.length > 0) {
      <div class="component-container">
        <div class="component-header">
          <h6 class="component-title">Uploaded Dispatch Device List</h6>
          <div class="component-actions">
            <button
              class="primary-button"
              type="button"
              (click)="
                exportToExcelUploadedDispatchedDeviceData(
                  dispatchUploadedDeviceList
                )
              "
              [disabled]="dispatchUploadedDeviceList.length === 0"
            >
              Export Uploaded Devices
              <mat-icon class="btn-icon">download</mat-icon>
            </button>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Device IMEI</th>
                <th>Device UIN</th>
                <th>Device ICCID</th>
                <th>Device Model Name</th>
              </tr>
            </thead>
            <tbody>
              @for (
                item of dispatchUploadedDeviceList
                  | paginate
                    : {
                        id: 'batchPaginateDispatchUploadedDeviceList',
                        itemsPerPage: size1,
                        currentPage: currentPage1,
                        totalItems: dispatchUploadedDeviceList.length,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.IMEI }}</td>
                  <td>{{ item.UIN }}</td>
                  <td>{{ item.ICCID }}</td>
                  <td>{{ item['TCU Model Name'] }}</td>
                </tr>
              }
            </tbody>
            @if (dispatchUploadedDeviceList.length === 0) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                      tabindex="0"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section -->
        <div class="component-footer">
          @if (dispatchUploadedDeviceList.length !== 0) {
            <app-common-component-pagination
              [totalItems]="dispatchUploadedDeviceList.length"
              [pageSize]="size1"
              [currentPage]="currentPage1"
              (pageChange)="onPageChange1($event)"
              (sizeChange)="onSizeChange1($event)"
            >
            </app-common-component-pagination>
          }
        </div>
      </div>
    }
  }
</div>
